import { makeGetQuery } from './useApi';

export const ME_KEY = 'me';

export const useMeQuery = makeGetQuery<{ [key: string]: any; }>(
  ME_KEY,
  (api) => () => api.teamRoles.me(),
);
